<nav
    class="nav-list"
    [class.settling]="settling()"
    aria-label="Main navigation"
>
    @if (viewSection(); as section) {
        <a
            class="back-row"
            role="button"
            tabindex="0"
            [attr.title]="collapsed() ? 'Back to ' + section.text : 'Back'"
            (click)="back()"
            (keydown.enter)="back()"
        >
            <i class="bi bi-chevron-left"></i>
            @if (!collapsed()) {
                <span>{{ section.text }}</span>
            }
        </a>
        <div class="divider"></div>

        @for (node of visibleItems(); track node.text) {
            @if (isGroup(node)) {
                <a
                    class="nav-row"
                    role="button"
                    tabindex="0"
                    [class.active]="isGroupActive(node)"
                    [attr.aria-expanded]="openGroup() === node"
                    [attr.title]="collapsed() ? node.text : null"
                    (click)="toggleGroup(node)"
                    (keydown.enter)="toggleGroup(node)"
                >
                    <i class="nav-icon {{ node.icon }}"></i>
                    @if (!collapsed()) {
                        <span class="nav-label">{{ node.text }}</span>
                        <i
                            class="chevron bi"
                            [class.bi-chevron-up]="openGroup() === node"
                            [class.bi-chevron-down]="openGroup() !== node"
                        ></i>
                    }
                </a>
                @if (openGroup() === node) {
                    <div class="group-kids">
                        @for (kid of node.children ?? []; track kid.text) {
                            <a
                                class="nav-row sub"
                                [class.active]="isItemActive(kid)"
                                [routerLink]="kid.route"
                                [queryParams]="kid.queryParams"
                                [attr.title]="collapsed() ? kid.text : null"
                                (click)="leafClicked(kid)"
                            >
                                <i class="nav-icon {{ kid.icon }}"></i>
                                @if (!collapsed()) {
                                    <span class="nav-label">{{
                                        kid.text
                                    }}</span>
                                }
                            </a>
                        }
                    </div>
                }
            } @else {
                <a
                    class="nav-row"
                    [class.active]="isItemActive(node)"
                    [routerLink]="node.route"
                    [queryParams]="node.queryParams"
                    [attr.title]="collapsed() ? node.text : null"
                    (click)="leafClicked(node)"
                >
                    <i class="nav-icon {{ node.icon }}"></i>
                    @if (!collapsed()) {
                        <span class="nav-label">{{ node.text }}</span>
                    }
                </a>
            }
        }
    } @else {
        @for (node of visibleItems(); track node.text) {
            @if (target(node); as dest) {
                <a
                    class="nav-row"
                    [class.active]="isSectionActive(node)"
                    [routerLink]="dest.route"
                    [queryParams]="dest.queryParams"
                    [attr.title]="collapsed() ? node.text : null"
                    (click)="drillInto(node, $event)"
                >
                    <i class="nav-icon {{ node.icon }}"></i>
                    @if (!collapsed()) {
                        <span class="nav-label">{{ node.text }}</span>
                        @if (isGroup(node)) {
                            <i class="chevron bi bi-chevron-right"></i>
                        }
                    }
                </a>
            }
        }
    }
</nav>

<!-- Supers only (RF-2798): back to the legacy nav and container width -->
<a
    class="nav-row legacy-toggle"
    role="button"
    tabindex="0"
    [attr.title]="collapsed() ? 'Switch to the classic navigation' : null"
    (click)="useLegacyNav()"
    (keydown.enter)="useLegacyNav()"
>
    <i class="nav-icon bi bi-arrow-counterclockwise"></i>
    @if (!collapsed()) {
        <span class="nav-label">Classic navigation</span>
    }
</a>

<!-- Collapse / expand handle, available at every level -->
<div
    class="collapse-handle"
    role="button"
    tabindex="0"
    [attr.title]="collapsed() ? 'Expand nav' : 'Collapse nav'"
    [attr.aria-label]="collapsed() ? 'Expand nav' : 'Collapse nav'"
    (click)="toggleCollapsed()"
    (keydown.enter)="toggleCollapsed()"
></div>
